export default "__VITE_ASSET__14OWM0fO__"